import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { ConfigProvider, App } from 'antd';

import Router from './pages/router';
import { store } from './store';

function Main() {
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#F57332',
            colorBgMask: '#1307014D',
          },
          components: {
            Switch: {
              colorPrimary: '#F57332',
              colorPrimaryHover: '#F57332',
            },
            Timeline: {
              itemPaddingBottom: 23,
            },
          },
        }}
      >
        <App>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </App>
      </ConfigProvider>
    </Provider>
  );
}

export default Main;
